import { castOvertimeUploadImageWidgetFormValuesToOvertimeImages } from '../../components/OvertimeForm/components/OvertimeUploadImageWidget';
import { OvertimeEmployeeType, OvertimeFormValues } from '../../components/OvertimeForm/form';
import { OvertimeEmployeeSaveInput, OvertimeSaveInput } from '../../globalTypes';
import { resetTimeInDate } from '../../utils/date';

type BaseEmployeeOvertimeDetails = {
  hours: number | null;
  extraHours: number | null;
  materialSurcharge: string | null;
  machinesUsage?: string | null;
  machinesHours?: number | null;
};

export function createOvertimeSaveInput({
  formValues,
  overtimeId,
  draftProject,
  pdfRedesignEnabled,
}: {
  formValues: OvertimeFormValues;
  overtimeId: string;
  draftProject: boolean;
  pdfRedesignEnabled: boolean;
}): OvertimeSaveInput {
  // To not break existing behavior, we have to provide employee hours as 0 when redesign is disabled
  const defaultEmployeeHours = !pdfRedesignEnabled ? 0 : null;

  const employees = formValues.employees
    .map<OvertimeEmployeeSaveInput | undefined>((employee) => {
      const baseEmployeeValues: BaseEmployeeOvertimeDetails = {
        hours: employee.hours ? Number(employee.hours) : defaultEmployeeHours,
        extraHours: employee.extraHours ? Number(employee.extraHours) : null,
        materialSurcharge: employee.materialSurcharge || null,
      };

      if (!pdfRedesignEnabled) {
        const machinesHours = employee.machinesUsage
          ? Number(employee.machinesUsage.replace(',', '.'))
          : null;

        baseEmployeeValues.machinesHours = machinesHours;
      } else {
        baseEmployeeValues.machinesUsage = employee.machinesUsage || null;
      }

      switch (employee.type) {
        case OvertimeEmployeeType.CUSTOM:
          return {
            customEmployee: {
              fullName: employee.fullName,
              role: employee.role,
              ...baseEmployeeValues,
            },
          };
        case OvertimeEmployeeType.SAP:
          return {
            sapEmployee: {
              employeeId: employee.employeeId,
              automaticRole: employee.automaticRole,
              role: !employee.automaticRole ? employee.role : null,
              ...baseEmployeeValues,
            },
          };
        default:
          // When sending request to server all other employee types
          // except CUSTOM and SAP are filtered
          return undefined;
      }
    })
    .filter((employee) => employee !== undefined);

  const date = resetTimeInDate(formValues.date);
  const orderDate = resetTimeInDate(formValues.orderDate);
  const endDate = formValues.endDate ? resetTimeInDate(formValues.endDate) : undefined;

  return {
    documentId: overtimeId,
    alias: formValues.no ? formValues.no.toString() : undefined,
    date,
    draftProjectNumber:
      draftProject && !!formValues.projectNumber ? formValues.projectNumber : undefined,
    clientName: formValues.clientName,
    professions: formValues.professions,
    clientReference: formValues.clientReference,
    description: formValues.description,
    orderDate,
    endDate,
    workName: formValues.workName,
    workDescription: formValues.workDescription,
    images: castOvertimeUploadImageWidgetFormValuesToOvertimeImages(formValues.images),
    employees,
  };
}
